<div class="col-12 mt-1">
  <strong class="mt-2"> Insérer une nouvelle Image : </strong>  <button type="button" class="q-btn-border q-main mx-1" (click)="ShowUploadNewImage()" title="Insérer une nouvelle image">
    <i class="fa-solid fa-download"></i>
  </button>
</div>
<div *ngIf="showUpload" class="col-12">
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="input-group p-3">
          <input type="text" class="form-control text-center" readonly value="{{newImgName}}">
          <label class="input-group-btn">
            <span class="btn btn-info q-light-secondary">
              <i class="fa fa-search"></i>
              <input type="file" fd-input id="uplImg" name="uplImg" file-name="newImgName" [(ngModel)]="fileInputValue" class="d-none" accept="image/x-png,image/gif,image/jpeg" (change)="onSelectChange($event)">
            </span>
          </label>
        </div>
      </div>
      <div class="row">
        <button class="q-btn q-main mx-3" (click)="ValidUpload()"><i [ngClass]="[isUploading ? 'fa-pulse fa-spin fa-spinner' : 'fa-save']" class="fas mr-2"></i>Enregistrer</button>
      </div>
    </div>
    <div class="col-6 q-font-12">
      <div class="row">
        <strong>dimensions max : 350px x 350px</strong>
      </div>
      <div class="row">
        <strong>taille max : 2Mo</strong>
      </div>
      <div class="row">
        <strong>Formats acceptés : .png, .jpeg, .gif</strong>
      </div>
    </div>
  </div>

</div>

<hr />

<!--bouton pour tester la suppression : <button (click)="canDelete = !canDelete" ><i class="fas fa-eye"></i></button>-->

<div class="row no-gutters" *ngIf="listAllImages && listAllImages.length > 0">
  <div class="col-12 text-center p-1">
    <div class="search">
      <div class="input-group p-1">
        <input type="search" class="form-control" placeholder="Nom de l'image" aria-label="search"
               [(ngModel)]="filter" (keyup)="filterImage()" />
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 overflow-auto pb-2">
    <table class="text-center w-100 table-striped">
      <thead>
        <tr>
          <th>Image</th>
          <th>Copier</th>
          <th>Chemin</th>
          <th>Insérée le</th>
          <th *ngIf="canDelete">Supprimer</th>
        </tr>
      </thead>
      <tbody>

        <ng-container *ngFor="let imageClient of listImages">

          <tr>
            <td class="px-2 q-td-name">
              <img class="q-img"
                   [src]="imageClient.Path" [title]="imageClient.Name">
              <!--{{imageClient.Name}}-->
            </td>
            <td class="px-2">
              <button (click)="copyImg(imageClient)" title="Copier le lien de l'image"><i class="far fa-copy"></i></button>
            </td>
            <td class="px-2 q-td-url">
              {{imageClient.Path}}
            </td>
            <td class="px-2">
              {{imageClient.UpdateDate|qDate}}
            </td>
            <td class="px-2" *ngIf="canDelete">
              <i class="fas fa-trash q-c-danger q-pointer" (click)="AffecteImageToDelete(imageClient);open(ModalDeleteValidation, false)" title="Supprimer l'image"></i>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div *ngIf="hasMoreImages" class="col-12 text-center p-1">
    <button type="button" class="btn" (click)="showMoreImages()"><i [ngClass]="[isLoadingMore ? 'fa-pulse fa-spin fa-spinner' : 'fa-plus']" class="fas"></i><span> Afficher plus</span></button>
  </div>
</div>


<!--  MODAL de validation de la suppression des images -->
<ng-template #ModalDeleteValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer définitivement cette image ?</h5>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row justify-content-center">
      <img class="q-img-todelete m-3"
           [src]="selectedImage.Path" [title]="selectedImage.Name">
    </div>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="deleteImage();"
              title="Supprimer l'image">
        <i [ngClass]="[isUploading ? 'fa-pulse fa-spin fa-spinner' : 'fa-trash']" class="fas mr-2"></i> Supprimer
      </button>
    </div>
  </div>
</ng-template>
